require('core-js/stable')
require('regenerator-runtime/runtime')
const title = 'Fossil Free Funds'
const description = 'Get your money out of fossil fuels. Fossil Free Funds is a search platform that informs and empowers everyday investors.'
const domain =  process.env.DOMAIN || 'https://fossilfreefunds.org'
// if were not the client (window) use the injected config otherwise create it
const Version = require('./data/Version.json')
const FootprintRanges = require('./data/FootprintRanges.json')
const TargetDateSeries = require('./data/TargetDateSeries.json')
const PlanNames = require('./data/PlanNames.json')
const CoreBenchmarks = require('./data/CoreBenchmarks.json')
const ExtendedBenchmarks = require('./data/ExtendedBenchmarks.json')
const FamilyFunds = require('./data/FamilyFunds.json')
const FundCategoryAll = require('./data/FundCategoryAll.json')
const FundFamilyAll = require('./data/FundFamilyAll.json')
const GefScoreNormalizersAllScored = require('./data/GefScoreNormalizersAllScored.json')
const GefScoreNormalizersGroups = require('./data/GefScoreNormalizersGroups.json')
const GefScoreNormalizersPeers = require('./data/GefScoreNormalizersPeers.json')
const CoalPolicyTool = require('./data/CoalPolicyTool.json')
const OilGasPolicyTracker = require('./data/OilGasPolicyTracker.json')
const TspHoldingStats = require('./data/TspHoldingStats.json')
const Changelog = require('./data/Changelog.json')
let config = {
  host: process.env.HOST || 'localhost',
  port: process.env.PORT || 3000,
  version: Version['version'],
  description: description,
  domain: domain,
  loggingOff: process.env.LOGGING_OFF,
  httpsRedirect: process.env.HTTPS_REDIRECT,
  gaKey: process.env.GA_KEY,
  gtmKey: process.env.GTM_KEY,
  apiHost: process.env.APIHOST || 'https://api.fossilfreefunds.org',
  apiPort: process.env.APIPORT || 443,
  imageSocialShare: 'fff-social-share.jpg',
  // for local testing
  // apiHost: 'http://localhost',
  // apiPort: 4000,
  //
  shareMessage: title,
  queryMaxFunds: 10,
  socialAppId: '1094061130685792',
  profilePath: 'fossil-fuel-investments',
  changelog: Changelog,
  gefScoreNormalizers: {
    overall: 22,
    balance: 15,
    policies: 7,
    allScored: GefScoreNormalizersAllScored['all_scored'],
    groups: GefScoreNormalizersGroups,
    peers: GefScoreNormalizersPeers,
  },
  routes: {
    home: '/',
    about: '/about',
    howitworks: '/how-it-works',
    videoTutorials: '/video-tutorials',
    fossilFuelCompanies: 'fossil-fuel-companies',
    carbonunderground200: '/carbon-underground-200',
    macroclimate50: '/macroclimate-50',
    morningstar: '/morningstar',
    carbonfootprint: '/carbon-footprint',
    banksInsurance: '/banks-insurance',
    clean200: '/clean-200',
    toolkit: '/fossil-free-action-toolkit',
    media: '/media',
    list: '/funds',
    compare: '/compare',
    clean: '/funds',
    fund: '/fund',
    families: '/families',
    targetdate: '/target-date-funds',
    targetDateFunds: '/target-date-funds',
    tspLanding: '/thrift-savings-plan',
    legal: '/legal',
    resources: '/resources',
    indexfunds: '/index-funds',
    signup: '/sign-up',
    notFound: '/not-found-404',
    tspToolkit: '/thrift-savings-plan-toolkit'
  },
  links: {
    changelog: 'https://iyv-charts.s3-us-west-2.amazonaws.com/files/',
    blog: 'https://fossilfreefunds.org/blog/',
    fficu200: 'https://www.ffisolutions.com/research-analytics-index-solutions/research-screening/the-carbon-underground-200/',
    macroclimate: 'https://macroclimate.com/about',
    mc50: 'https://macroclimate.com/coal',
    mc50experts: 'http://poll.visionprize.com/#the-1-problem-is-coal',
    globalenergyobservatory: 'http://globalenergyobservatory.org/index.php',
    donate: 'https://connect.clickandpledge.com/w/Form/9d5e83e2-b2d9-43eb-9834-043d7558b785',
    contact: 'https://www.asyousow.org/contact',
    speakout: 'https://go.asyousow.org/take-action-fossil-free-funds',
    signup: 'https://go.asyousow.org/sign-up-fossil-free-funds',
    contactJill: 'mailto:jcourtenay*asyousow.org?subject=Fossil%20Free%20Funds&body=Replace%20asterisk%20in%20address%20to%20send',
    contactCyrus: 'mailto:cnemati*asyousow.org?subject=Fossil%20Free%20Funds&body=Replace%20asterisk%20in%20address%20to%20send',
    contactAndrew: 'mailto:andrew*fossilfreefunds.org?subject=Fossil%20Free%20Funds&body=Replace%20asterisk%20in%20address%20to%20send',
    ays: 'http://www.asyousow.org',
    aysabout: 'http://www.asyousow.org/about-us',
    ceres: 'http://www.ceres.org/investor-network/resolutions#!/subject=&year=&company=&filer=&sector=&status=&memo=&all=&=',
    fff: 'https://fossilfreefunds.org',
    dff: 'https://deforestationfreefunds.org',
    gef: 'https://genderequalityfunds.org',
    sjf: 'https://socialjusticefunds.org',
    wff: 'https://weaponfreefunds.org',
    gff: 'https://gunfreefunds.org',
    tff: 'https://tobaccofreefunds.org',
    pff: 'https://prisonfreefunds.org',
    iyv: 'https://investyourvalues.org',
    iyvPlans: 'https://investyourvalues.org/retirement-plans',
    dffFund: 'https://deforestationfreefunds.org/fund',
    fffFund: 'https://fossilfreefunds.org/funds',
    wffFund: 'https://weaponfreefunds.org/funds',
    pffFund: 'https://prisonfreefunds.org/fund',
    compareFeedback: 'https://forms.gle/cdJG5C7WoGxKkEx78',
    aysinvest: 'https://www.asyousow.org/invest-your-values/',
    proxypreview: 'http://www.proxypreview.org',
    aysvoteshares: 'http://www.asyousow.org/about-us/vote-your-shares/',
    pledge: 'https://www.divestinvestindividual.org/',
    ffi: 'https://www.ffisolutions.com/',
    yoursri: 'https://yoursri.com/',
    spg: 'http://www.thesouthpolegroup.com/',
    issethix: 'https://www.issgovernance.com/esg/iss-ethix/',
    yoursrimethodology: 'https://professional.yoursri.com/media-new/download/appendix-3-carbon-methodology.pdf',
    morningstar: 'https://www.morningstar.com/',
    earthhq: 'https://earthhq.foe.org/defend-the-rainforest',
    friends: 'http://www.foe.org/',
    foemain: 'http://www.foe.org/DeforestationFreeAction',
    foeabout: 'http://www.foe.org/about-us/friends-of-the-earth-international',
    foereport: 'http://webiva-downton.s3.amazonaws.com/877/72/7/8646/Invested_in_Exploitation.Digital.compressed.pdf',
    profundo: 'http://www.profundo.nl',
    ran: 'http://www.ran.org/sf20scorecard',
    uocs: 'http://www.ucsusa.org/global-warming/stop-deforestation/palm-oil-scorecard-2015#.V358U_krLGg',
    zoolondon: 'http://www.sustainablepalmoil.org/companies/',
    supplychange: 'http://www.supply-change.org/commodity/palm',
    greenpeace: 'http://www.greenpeace.org/usa/palm-oil-scorecard-are-brands-doing-enough-for-indonesias-rainforests/',
    dffFund: 'https://www.deforestationfreefunds.org/funds',
    clean200: 'https://www.asyousow.org/clean200',
    clean200Methodology: 'https://www.clean200.org/methodology/',
    whitePaper: 'https://www.asyousow.org/ays_report/aligning-defined-contribution-plans-with-corporate-sustainability-goals/',
    socialFFFfb: 'https://www.facebook.com/FossilFreeFunds/',
    socialFFFtwitter: 'https://twitter.com/FossilFreeFunds',
    socialAYSfb: 'https://www.facebook.com/asyousow.org/',
    socialAYStwitter: 'https://twitter.com/asyousow',
    socialAYSinstagram: 'https://www.instagram.com/_asyousow_/',
    nytHome: 'https://www.nytimes.com/2017/10/13/business/mutfund/mutual-funds-low-carbon.html',
    bloombergHome: 'https://www.bna.com/ge-microsoft-urged-n57982069981/',
    guardianHome: 'https://www.theguardian.com/sustainable-business/2016/oct/27/investment-advice-retirement-portfolio-tips-climate-change-financial-risk',
    fastcompanyHome: 'https://www.fastcompany.com/3059618/how-to-convince-your-employer-to-divest-your-401k-from-fossil-fuels',
    thinkprogressHome: 'https://thinkprogress.org/theres-now-a-way-to-find-out-how-much-of-your-retirement-is-invested-in-fossil-fuels-5f63efa9e784/',
    ussifperf: 'https://www.ussif.org/performance',
    ussif: 'https://www.ussif.org/',
    gcel: 'https://coalexit.org/',
    gogel: 'https://gogel.org/',
  },
  // for recent blog posts component
  blog: [
    {
      url: '2026/10/08/dueling-401k-lawsuits-putting-climate-risk-on-trial.html',
      image: '/blog/assets/img/post-thumbnails/dueling-401k-lawsuits-thumbnail.jpg',
      title: 'The dueling 401(k) lawsuits putting climate risk on trial',
      subtitle: "Mutual funds inside 401(k) plans are at the center of a growing legal fight that could redefine how employers address the impact of climate change on their employees.",
      date: '2026-10-08'
    },
    {
      url: '2026/08/25/green-iras.html',
      image: '/blog/assets/img/post-thumbnails/green-iras-thumbnail.jpg',
      title: 'All About Future-Friendly Green IRAs',
      subtitle: "Sustainable, socially responsible Individual Retirement Accounts (IRAs) can be an important tool to protect your savings from climate-related financial risk. They also actively support investment in the future you want to retire in.",
      date: '2026-08-25'
    },
    {
      url: '2026/05/13/tracing-connection-between-401k-civilian-casualties-war-iran.html',
      image: '/blog/assets/img/post-thumbnails/wff-shoes-thumbnail.jpg',
      title: 'Tracing the connection between your 401(k) and civilian casualties in the war on Iran',
      subtitle: "More than 100 children were killed when an Iranian elementary school was struck by American missiles. The companies that made those weapons are likely in your retirement savings.",
      date: '2026-05-13'
    },
    {
      url: '2025/11/24/turning-retirement-savings-force-workplace-equity.html',
      image: '/blog/assets/img/post-thumbnails/sjf-dei-thumbnail.png',
      title: 'Turning Retirement Savings into a Force for Workplace Equity',
      subtitle: "Companies that fail to disclose workforce demographics, hiring practices, promotion pathways, and retention outcomes leave investors in the dark about how they responsibly and effectively manage a healthy workforce. This is where Social Justice Funds plays an essential role.",
      date: '2025-11-24'
    },
    {
      url: '2025/11/10/advancing-racial-justice-social-justice-funds.html',
      image: '/blog/assets/img/post-thumbnails/sjf-rji-thumbnail.png',
      title: 'Advancing Racial Justice with Social Justice Funds',
      subtitle: "Most people think of retirement savings as a safe, neutral part of life planning. But the truth is, every dollar invested tells a story. Social Justice Funds helps investors see not just the financial performance of funds, but also the racial justice implications behind them.",
      date: '2025-11-10'
    },
    {
      url: '2025/10/30/diversity-dividend-401k-funds.html',
      image: '/blog/assets/img/post-thumbnails/sjf-returns-thumbnail.png',
      title: 'The Diversity Dividend in Your 401(k) Funds',
      subtitle: "As we worked on Social Justice Funds, our newest Invest Your Values tool, we wondered: How do the returns of mutual funds correlate with their gender equality, diversity disclosures, racial justice, and LGBTQ+ equity ratings? Our results suggest that DEI and financial returns have a positive correlation.",
      date: '2025-10-30'
    },
    // {
    //   url: '2025/10/30/introducing-social-justice-funds.html',
    //   image: '/blog/assets/img/post-thumbnails/introducing-sjf-thumbnail.png',
    //   title: 'Introducing Social Justice Funds',
    //   subtitle: "You believe in justice. You show up, speak out, and push for change in your community and workplace. But what if your retirement savings are silently working against everything you stand for? There’s a new way to align your retirement savings with social justice: Social Justice Funds.",
    //   date: '2025-10-30'
    // },
    // {
    //   url: '2025/10/17/ice-is-in-your-401k.html',
    //   image: '/blog/assets/img/post-thumbnails/ice-is-in-your-401k-thumbnail.png',
    //   title: 'ICE is in your 401(k)',
    //   subtitle: "There’s a hidden connection between your savings and the business of immigrant incarceration. Nearly 90% of people in ICE custody are held in facilities run by private companies like CoreCivic and GEO Group. If you have a 401(k) from your employer, it’s likely investing your savings in these private prison operators.",
    //   date: '2025-10-17'
    // },
    // {
    //   url: '2025/09/17/employees-already-keeping-billions-out-fossil-fuels-via-401ks.html',
    //   image: '/blog/assets/img/post-thumbnails/billions-saved-from-fossil-fuels-thumbnail.png',
    //   title: 'Employees are already keeping billions out of fossil fuels via their 401(k)s',
    //   subtitle: "Workers are already taking action to protect their savings by choosing sustainable investment options in their 401(k) plans. Our new analysis estimates that by choosing a green 401(k) fund, U.S. employees are keeping a lot of money from being invested in fossil fuel companies.",
    //   date: '2025-09-17'
    // },
    // {
    //   url: '2025/07/23/what-to-do-insurance-company-supporting-fossil-fuels.html',
    //   image: '/blog/assets/img/post-thumbnails/green-insurance-thumbnail.png',
    //   title: 'What to do if your insurance company is supporting fossil fuels',
    //   subtitle: "Extreme weather events are putting serious strain on insurance companies. But primary insurers and reinsurers continue to underwrite and invest in fossil fuels, even as they face dramatic losses associated with catastrophic weather-related events, driven by the high-carbon industries they support.",
    //   date: '2025-07-23'
    // },
    // {
    //   url: '2025/07/14/investing-peaceful-future-video.html',
    //   image: '/blog/assets/img/post-thumbnails/weapon-ploughshares-5-thumbnail.png',
    //   title: 'Investing in a Peaceful Future – VIDEO',
    //   subtitle: "This video explores how your retirement savings might be financing arms manufacturers making nuclear missiles, cluster bombs, and other controversial military weapons used in wars and armed conflicts all over the world. In less than 4 minutes, Grant Bradski walks you through As You Sow’s Weapon Free Funds tool.",
    //   date: '2025-07-14'
    // },



    // {
    //   url: '2025/06/24/google-fossil-free-fund-option-by-the-numbers.html',
    //   image: '/blog/assets/img/post-thumbnails/google-parnassus-financed-emissions-thumbnail.png',
    //   title: 'Google’s fossil free fund option, by the numbers',
    //   subtitle: "When the Google 401(k) added a fossil-free fund, it didn’t just give employees a climate-conscious sustainable investment option with comparable returns. It gave employees a way to directly reduce their fossil fuel investments, as well as their financed emissions.",
    //   date: '2025-06-24'
    // },
    // {
    //   url: '2025/05/22/bankrolling-bombs-how-your-401k-funds-war-machine-what-you-can-do-about-it.html',
    //   image: '/blog/assets/img/post-thumbnails/weapon-ploughshares-4-thumbnail.png',
    //   title: 'Bankrolling Bombs',
    //   subtitle: "How Your 401(k) Funds the War Machine and What You Can Do About It",
    //   date: '2025-05-22'
    // },
    // {
    //   url: '2025/04/05/humanitarian-impacts-investment-risks-conventional-weapons.html',
    //   image: '/blog/assets/img/post-thumbnails/weapon-ploughshares-3-thumbnail.png',
    //   title: 'The Humanitarian Impacts and Investment Risks of Conventional Weapons',
    //   subtitle: "Conventional weapons cause immense human suffering, particularly when they are used with excessive force or indiscriminately against civilians, in violation of international human rights law.",
    //   date: '2025-04-05'
    // },
    // {
    //   url: '2025/03/12/ethical-financial-risks-investing-controversial-weapons.html',
    //   image: '/blog/assets/img/post-thumbnails/weapon-ploughshares-2-thumbnail.png',
    //   title: 'The Ethical and Financial Risks of Investing in Controversial Weapons',
    //   subtitle: "Many military weapons are considered controversial weapons due to the indiscriminate harm they cause to civilians, violating international humanitarian principles. Investing in controversial weapons makers doesn’t just threaten global peace – it also threatens your savings.",
    //   date: '2025-03-12'
    // },
    // {
    //   url: '2025/02/06/university-retirement-plans-funding-destruction-students-future.html',
    //   image: '/blog/assets/img/post-thumbnails/university-annuities-thumbnail.jpg',
    //   title: 'University Retirement Plans are Funding the Destruction of their Students’ Future',
    //   subtitle: "We analyzed 10 defined contribution plans offered by five large universities: Columbia, Harvard, Northwestern, Princeton, and Notre Dame. We found that billions of dollars in university employee retirement savings are invested in companies with significant environmental and social risks.",
    //   date: '2025-02-06'
    // },
    // {
    //   url: '2025/02/04/you-might-be-invested-in-military-weapon-manufacturers.html',
    //   image: '/blog/assets/img/post-thumbnails/weapon-ploughshares-1-thumbnail.png',
    //   title: 'You Might be Invested in Military Weapon Manufacturers',
    //   subtitle: "What if I told you your hard-earned retirement savings are likely invested in companies that manufacture weapons of war?",
    //   date: '2025-02-04'
    // },
    // {
    //   url: '2024/11/12/how-google-found-fossil-free-fund-401k.html',
    //   image: '/blog/assets/img/post-thumbnails/google-fossil-free-thumbnail.jpg',
    //   title: 'How Google found a fossil free fund for their 401(k) ',
    //   subtitle: "Many U.S. employees saving for retirement are invested in companies fueling the climate crisis, exposing their savings to climate-related financial risk. Employees are increasingly calling for climate-safe fund options to avoid these risks.",
    //   date: '2024-11-12'
    // },
    // {
    //   url: '2024/08/27/what-to-do-bank-financing-climate-crisis.html',
    //   image: '/blog/assets/img/post-thumbnails/green-banks-thumbnail.jpg',
    //   title: 'What to do if your bank is financing the climate crisis',
    //   subtitle: "Despite clear evidence and global consensus of the need to shift away from fossil fuels because of climate change, the fossil fuel industry continues to expand production and roll back environmental commitments. This expansion is facilitated by financing from the world’s largest banks.",
    //   date: '2024-08-27'
    // },
    // {
    //   url: '2024/07/25/earth-set-heat-records-13-straight-months-big-banks-continue-finance-fossil-fuels.html',
    //   image: '/blog/assets/img/post-thumbnails/ffb-ratings-updated-thumbnail.jpg',
    //   title: 'The Earth has set heat records for 13 straight months - but Big Banks continue to finance fossil fuel expansion',
    //   subtitle: "If your 401(k), IRA, or mutual funds are invested in banks that finance fossil fuels, it could impact your financial returns. We've updated our Fossil Fuel Finance ratings to use the most recent data on bank financial commitments to fossil fuels.",
    //   date: '2024-07-25'
    // },
    // {
    //   url: '2024/06/18/is-your-401k-invested-in-bomb-makers.html',
    //   image: '/blog/assets/img/post-thumbnails/weapon-bonds-thumbnail.png',
    //   title: 'Is Your 401(k) Invested in Bomb Makers?',
    //   subtitle: "When you think about your 401(k), you probably imagine your money working hard towards your secure and comfortable retirement. But  401(k)s have big holdings in companies that make bombs and missiles - including nuclear weapons, cluster bombs, and other arms prohibited by international treaties.",
    //   date: '2024-06-18'
    // },
    // {
    //   url: '2024/04/30/tech-employees-5-billion-fossil-fuel-401k-price-tag.html',
    //   image: '/blog/assets/img/post-thumbnails/waterloo-tech-report-thumbnail.png',
    //   title: 'Tech employees’ $5 billion fossil fuel 401(k) price tag',
    //   subtitle: "Researchers at the University of Waterloo, in partnership with As You Sow, have released a new report finding that 2 million employees from 12 tech-sector companies could have earned an estimated $5.1 billion in additional returns had their companies moved to decarbonize their retirement plan holdings 10 years ago.",
    //   date: '2024-04-30'
    // },
    // {
    //   url: '2024/02/01/our-retirement-savings-own-one-fifth-us-fossil-fuel-stocks.html',
    //   image: '/blog/assets/img/post-thumbnails/ff-market-cap-from-dc-plans-thumbnail.png',
    //   title: 'Our retirement savings own one fifth of U.S. fossil fuel stocks',
    //   subtitle: "Just how much does the fossil fuel industry depend on our 401(k) savings? It turns out: quite a lot. We estimated the total amount invested in U.S. fossil fuel companies by the retirement savings accounts of American workers. We then compared that to the total market cap of those companies and estimate that 19% comes from our 401(k)s and IRAs.",
    //   date: '2024-02-01'
    // },
    // {
    //   url: '2023/07/18/cluster-bombs-landmines-nuclear-weapons-found-largest-401k-fund-managers.html',
    //   image: '/blog/assets/img/post-thumbnails/weapon-manager-ratings-thumbnail.jpg',
    //   title: 'Cluster bombs, landmines, nuclear weapons found in largest 401(k) fund managers',
    //   subtitle: "The largest U.S. mutual fund managers, responsible for funds found across thousands of corporate 401(k) plans, have billions invested in nuclear weapons and controversial weapons like white phosphorus and cluster bombs. But investing in companies involved in producing controversial weapons is a risky business.",
    //   date: '2023-07-18'
    // },
    // {
    //   url: '2023/07/10/as-you-sow-engages-companies-safeguard-employee-retirement-savings-climate-change.html',
    //   image: '/blog/assets/img/post-thumbnails/401k-climate-resolutions-thumbnail.jpg',
    //   title: 'As You Sow engages companies to safeguard employee retirement savings from climate change',
    //   subtitle: "Over the past year, shareholders at Microsoft, Amazon, Netflix, Comcast, and Campbell’s Soup have voted on proposals from As You Sow asking for information on how these companies are protecting employees from climate-related investment risk in their 401(k) retirement plans.",
    //   date: '2023-07-10'
    // },
    // {
    //   url: '2023/05/16/are-your-401k-savings-financing-fossil-fuel-expansion.html',
    //   image: '/blog/assets/img/post-thumbnails/fossil-fuel-bonds-thumbnail.jpg',
    //   title: 'Are your 401(k) savings financing fossil fuel expansion?',
    //   subtitle: "Bonds in employer-offered 401(k)s directly provide cash to fossil fuel projects adding risk to portfolios. Our newest tool is here to help. Information on these holdings is critical because coal, oil, and gas companies are increasingly turning to the bond market to access inexpensive debt for new extraction and pipeline projects.",
    //   date: '2023-05-16'
    // },
    // {
    //   url: '2023/04/24/vanguard-protect-our-finances-from-climate-risk.html',
    //   image: '/blog/assets/img/post-thumbnails/vanguard-letter-thumbnail.jpg',
    //   title: 'Vanguard, protect our finances from climate risk!',
    //   subtitle: "Vanguard’s customers expect the asset manager to exercise duties of loyalty and care in its decisions. But Vanguard’s actions raise the question of whether it is insufficiently managing the risks to client investments from climate change.",
    //   date: '2023-04-24'
    // },
    // {
    //   url: '2023/03/29/these-200-clean-energy-leaders-outperform-dirty-energy-investments.html',
    //   image: '/blog/assets/img/post-thumbnails/clean200-2023-thumbnail.jpg',
    //   title: 'These 200 clean energy leaders outperform dirty energy investments',
    //   subtitle: "In order to help investors identify opportunities in the clean energy economy, As You Sow and Corporate Knights recently released another update to the Carbon Clean 200™: a list of 200 companies leading the clean energy transition.",
    //   date: '2023-03-29'
    // },
    // {
    //   url: '2023/02/16/defund-gun-violence-in-your-401k.html',
    //   image: '/blog/assets/img/post-thumbnails/gff-update-thumbnail.jpg',
    //   title: 'Defund gun violence in your 401(k)',
    //   subtitle: "Climate change isn’t the only risk facing your savings. Retirement funds are also invested in gun companies profiting from mass shootings. But with Gun Free Funds, we have the power to cut our financial ties to gun violence.",
    //   date: '2023-02-16'
    // },
    // {
    //   url: '2023/01/12/federal-reserve-already-climate-policymaker.html',
    //   image: '/blog/assets/img/post-thumbnails/fed-climate-thumbnail.jpg',
    //   title: 'The Federal Reserve is already a climate policymaker ',
    //   subtitle: "The Federal Reserve has announced that it doesn’t intend to “be a climate policymaker”. But what impacts could this hands-off approach have on your retirement savings?",
    //   date: '2023-01-12'
    // },
    // {
    //   url: '2022/09/13/finance-insurance-ratings-added-fossil-free-funds.html',
    //   image: '/blog/assets/img/post-thumbnails/banks-insurers-thumbnail.jpg',
    //   title: 'Finance and insurance ratings added to Fossil Free Funds',
    //   subtitle: "Financial companies supporting fossil fuels may be hidden in your retirement portfolio. Our new Fossil Fuel Finance and Insurance ratings score mutual funds and ETFs based on their investments in banks and insurers providing loans and underwriting that support fossil fuel projects.",
    //   date: '2022-09-13'
    // },
    // {
    //   url: '2022/08/30/does-blackrock-lifepath-esg-index-reduce-climate-risk.html',
    //   image: '/blog/assets/img/post-thumbnails/lifepath-esg-thumbnail.jpg',
    //   title: 'Does the BlackRock LifePath ESG Index reduce climate risk?',
    //   subtitle: "Look inside many large U.S. corporate 401(k) plans, and you’ll find the BlackRock LifePath Index. BlackRock has released sustainable versions of their popular LifePath target date funds, but investors question if this new fund series truly reduces climate risk, or if it’s just greenwashing.",
    //   date: '2022-08-30'
    // },
    // {
    //   url: '2022/06/21/which-vanguard-fund-more-sustainable-vtsax-vftnx.html',
    //   image: '/blog/assets/img/post-thumbnails/VTSAX-VFTNX-thumbnail.jpg',
    //   title: 'Which Vanguard fund is more sustainable, VTSAX or VFTNX?',
    //   subtitle: "In polls with investors broadly, more than 70% say that they would like to invest sustainably and, specifically, not in oil, coal, and deforestation. Given the threat that climate change poses to workers’ life savings, it makes sense that 401(k) and other mutual fund investors would be looking to safeguard financial security over time by mitigating climate change-related financial and economic risks.",
    //   date: '2022-06-21'
    // },
    // {
    //   url: '2022/03/21/urge-asset-managers-adopt-no-deforestation-policy.html',
    //   image: '/blog/assets/img/post-thumbnails/intl-day-forests-thumbnail.jpg',
    //   title: 'Urge asset managers to adopt a No Deforestation policy',
    //   subtitle: "Happy International Day of Forests! Today, people all over the world are taking action to protect our forests and raising awareness of their importance. If you’re invested in mutual funds or saving for retirement, you have the power to help end deforestation once and for all. Sign a petition asking your asset manager to adopt a No Deforestation policy!",
    //   date: '2022-03-21'
    // },
    // {
    //   url: '2021/10/19/401k-plans-forcing-people-invest-fossil-fuels.html',
    //   image: '/blog/assets/img/post-thumbnails/401ks-thumbnail.jpg',
    //   title: '401(k) plans are forcing people to invest in fossil fuels ',
    //   subtitle: "Large companies are making increasingly strong commitments to address climate change by sourcing clean energy and reducing emissions in operations. But our research finds that their retirement plans are directing employee savings into fossil fuel companies that are fueling the climate crisis. We've rated the 401(k) plans of seven major S&P 500 companies, with more on the way.",
    //   date: '2021-10-19'
    // },
    // {
    //   url: '2021/07/16/target-date-funds.html',
    //   image: '/blog/assets/img/post-thumbnails/target-dates-thumbnail.jpg',
    //   title: 'ESG ratings for target date funds',
    //   subtitle: "We’ve added a new group of funds commonly found in company 401(k)s to our database. There are 12 target date fund series rated so far, from major asset managers like Vanguard, BlackRock, Fidelity, and TIAA. These funds represent hundreds of billions in AUM. Now you can see how much of that is invested in fossil fuel companies, arms manufacturers, and private prison companies.",
    //   date: '2021-07-16'
    // },
    // {
    //   url: '2021/04/20/blackrocks-carbon-transition-fund-packed-big-oil.html',
    //   image: '/blog/assets/img/post-thumbnails/blk-ltcu-thumbnail.jpg',
    //   title: 'Why is BlackRock’s Carbon Transition fund packed with Big Oil?',
    //   subtitle: "The recently released BlackRock U.S. Carbon Transition Readiness ETF (ticker LCTU) holds major oil and gas companies including Exxon, Chevron, ConocoPhillips, Marathon Petroleum, and Devon Energy; fossil-fired utilities including Berkshire Hathaway, Consolidated Edison, and UGI; and oil field services and pipeline companies including Kinder Morgan, Baker Hughes, and Schlumberger.",
    //   date: '2021-04-20'
    // },
    // {
    //   url: '2021/01/21/updating-rating-methodologies.html',
    //   image: '/blog/assets/img/post-thumbnails/grade-updates-thumbnail.jpg',
    //   title: 'Updating the Invest Your Values rating methodologies',
    //   subtitle: "Periodically, we review the Invest Your Values rating methodologies and adjust how we're assigning the A, B, C, D, and F letter grades. As the market changes, the distribution of exposure to companies changes, and the distribution of funds across grade groups can get skewed. By regularly measuring the distribution of results and adjusting the grade assignments, we aim to keep everything up to date.",
    //   date: '2021-01-21'
    // },
  ],
  // for email capture sign up forms
  signupForm: {
    url: 'https://go.asyousow.org/l/344561/2017-05-15/4zx',
    id: '344561_1307pi_344561_1307'
  },
  // for get started component driving people to "Clean" lists
  getStartedInput: {
    label: 'Top-rated funds',
    title: 'Top-rated funds | Fossil Free Funds',
    faclass: 'fa-angle-double-right'
  },
  // footprint date IF NEEDED
  footprintDate: 'Nov. 2020',
  // for footprint scoring
  footprintRanges: FootprintRanges,
  // core and extended benchmarks for footprint charts and returns comparisons
  coreBenchmarks: CoreBenchmarks,
  extendedBenchmarks: ExtendedBenchmarks,
  // asset managers for Family view
  familyFunds: FamilyFunds,
  // target dates
  targetDateSeries: TargetDateSeries,
  // Plans to link out to IYV-APP
  planNames: PlanNames,
  // for fossil finance popups
  coalPolicyTool: CoalPolicyTool,
  oilGasPolicyTracker: OilGasPolicyTracker,
  // for TSP landing page
  tspHoldingStats: TspHoldingStats,
  // NOT NEEDED (used in DFF)
  engagementFunds: [
  ],
  /*ignore jslint start*/
  formOptions: {
    market: [
        { name: 'All funds', value:'Show all funds' },
        { name: 'United States', value:'US' },
        // { name: 'Hong Kong', value:"HK" },
        // { name: 'United Kingdom', value:"UK" },
        // { name: 'Denmark', value:"DK" },
        // { name: 'France', value:"FR" },
        // { name: 'Germany', value:"DE" }
    ],
    type: [
        { name: 'All funds', value: 'All funds' },
        { name: 'Open-end funds', value: 'Open' },
        { name: 'Exchange-traded funds (ETFs)', value: 'ETF' },
        // { name: 'Common/Collective trusts', value: 'TSP' },
        { name: 'Variable annuities', value: 'VA' },
    ],
    diversified : [
        { name: 'All funds', value: false },
        { name: 'Diversified', value: 'false' },
        { name: 'Non-diversified', value: 'true' }
    ],
    sri : [
        { name: 'All funds', value: false },
        { name: 'Sustainability mandate', value: '1.0'},
        { name: 'US-SIF funds', value: '1.5'},
    ],
    fundUssif : [
        { name: 'All funds', value: false },
        { name: 'US-SIF funds', value: 1.5},
    ],
    targetDate : [
        { name: 'All funds', value: false },
        { name: 'Target date funds', value: '1.0'},
    ],
    fundPerformance : [
        { name: 'All funds', value: false },
        { name: 'Positive 1-year returns', value: 'trailing_return_y1' },
        { name: 'Positive 3-year returns', value: 'trailing_return_y3' },
        { name: 'Positive 5-year returns', value: 'trailing_return_y5' },
        { name: 'Positive 10-year returns', value: 'trailing_return_y10' },
        { name: 'Positive 15-year returns', value: 'trailing_return_y15' },
        { name: 'Positive 20-year returns', value: 'trailing_return_y20' },
    ],
    deiGrade : [
        { name: 'All funds', value: false },
        { name: 'Diversity disclosures grade A', value: 1 },
        { name: 'Diversity disclosures grade B or higher', value: 2 },
        { name: 'Diversity disclosures grade C or higher', value: 3 },
        { name: 'Diversity disclosures grade D or higher', value: 4 },
    ],
    rjiGrade : [
        { name: 'All funds', value: false },
        { name: 'Racial justice grade A', value: 1 },
        { name: 'Racial justice grade B or higher', value: 2 },
        { name: 'Racial justice grade C or higher', value: 3 },
        { name: 'Racial justice grade D or higher', value: 4 },
    ],
    hrcGrade : [
        { name: 'All funds', value: false },
        { name: 'LGBTQ+ equity grade A', value: 1 },
        { name: 'LGBTQ+ equity grade B or higher', value: 2 },
        { name: 'LGBTQ+ equity grade C or higher', value: 3 },
        { name: 'LGBTQ+ equity grade D or higher', value: 4 },
    ],
    fffGrade : [
        { name: 'All funds', value: false },
        { name: 'Fossil fuel grade A', value: 1 },
        { name: 'Fossil fuel grade B or higher', value: 2 },
        { name: 'Fossil fuel grade C or higher', value: 3 },
        { name: 'Fossil fuel grade D or higher', value: 4 },
    ],
    ffbGrade : [
        { name: 'All funds', value: false },
        { name: 'Fossil finance grade A', value: 1 },
        { name: 'Fossil finance grade B or higher', value: 2 },
        { name: 'Fossil finance grade C or higher', value: 3 },
        { name: 'Fossil finance grade D or higher', value: 4 },
    ],
    ffiGrade : [
        { name: 'All funds', value: false },
        { name: 'Fossil insurance grade A', value: 1 },
        { name: 'Fossil insurance grade B or higher', value: 2 },
        { name: 'Fossil insurance grade C or higher', value: 3 },
        { name: 'Fossil insurance grade D or higher', value: 4 },
    ],
    dffGrade : [
        { name: 'All funds', value: false },
        { name: 'Deforestation grade A', value: 1 },
        { name: 'Deforestation grade Engagement or higher', value: 1.5 },
        { name: 'Deforestation grade B or higher', value: 2 },
        { name: 'Deforestation grade C or higher', value: 3 },
        { name: 'Deforestation grade D or higher', value: 4 },
    ],
    gefGrade : [
        { name: 'All funds', value: false },
        { name: 'Gender equality grade A', value: 1 },
        { name: 'Gender equality grade B or higher', value: 2 },
        { name: 'Gender equality grade C or higher', value: 3 },
        { name: 'Gender equality grade D or higher', value: 4 },
    ],
    wffGrade : [
        { name: 'All funds', value: false },
        { name: 'Weapon grade A', value: 1 },
        { name: 'Weapon grade B or higher', value: 2 },
        { name: 'Weapon grade C or higher', value: 3 },
        { name: 'Weapon grade D or higher', value: 4 },
    ],
    gffGrade : [
        { name: 'All funds', value: false },
        { name: 'Civilian firearm grade A', value: 1 },
        { name: 'Civilian firearm grade B or higher', value: 2 },
        { name: 'Civilian firearm grade C or higher', value: 3 },
        { name: 'Civilian firearm grade D or higher', value: 4 },
    ],
    tffGrade : [
        { name: 'All funds', value: false },
        { name: 'Tobacco grade A', value: 1 },
        // { name: 'Tobacco grade Engagement or higher', value: 1.5 },
        { name: 'Tobacco grade B or higher', value: 2 },
        { name: 'Tobacco grade C or higher', value: 3 },
        { name: 'Tobacco grade D or higher', value: 4 },
    ],
    pffGrade : [
        { name: 'All funds', value: false },
        { name: 'Prison industrial complex grade A', value: 1 },
        { name: 'Prison industrial complex grade B or higher', value: 2 },
        { name: 'Prison industrial complex grade C or higher', value: 3 },
        { name: 'Prison industrial complex grade D or higher', value: 4 },
    ],
    clean : [
        { name: 'All funds', value: false },
        { name: 'A grade funds only', value: 'true' }
    ],
    currency: [],
    currencyAll: [
      { name: 'All funds' },
      { name: 'US Dollar' },
    ],
    currencyUS: [],
    currencyUK: [],
    currencyHK: [],
    currencyDK: [],
    currencyFR: [],
    currencyDE: [],
    fundGroup: [],
    fundGroupAll: [
      { name: 'All funds' },
      { name: 'Allocation' },
      { name: 'International Equity' },
      { name: 'Sector Equity' },
      { name: 'U.S. Equity' },
      // { name: 'U.S. Small/Mid Cap Equity' },
      // { name: 'U.S. Large Cap Equity' },
    ],

    fundGroupUS: [],
    fundGroupUK: [],
    fundGroupHK: [],
    fundGroupDK: [],
    fundGroupFR: [],
    fundGroupDE: [],
    fundCategory: [],
    fundCategoryAll: FundCategoryAll,
    fundCategoryUS: [],
    fundCategoryUK: [],
    fundCategoryHK: [],
    fundCategoryDK: [],
    fundCategoryFR: [],
    fundCategoryDE: [],
    fundFamily: [],
    fundFamilyAll: FundFamilyAll,
    fundFamilyUS : [],
    fundFamilyUK: [],
    fundFamilyHK: [],
    fundFamilyDK: [],
    fundFamilyFR: [],
    fundFamilyDE: [],
  },
  /*ignore jslint end*/

  app: {
    title: title,
    description: description,
    head: {
      defaultTitle: title,
      titleTemplate: '%s | ' + title,
      meta: [
        {name: 'description', content: description},
        {charset: 'utf-8'},
        // twitter
        {property: 'twitter:card', content: 'summary_large_image' },
        {property: 'twitter:site', content: '@fossilfreefunds' },
        {property: 'twitter:title', content: title },
        {property: 'twitter:description', content: description},
        {property: 'twitter:creator', content: '@fossilfreefunds'},
        {property: 'twitter:image', content: ''},
        // {property: 'twitter:image', content: ''},

        // og
        {property: 'og:site_name', content: title },
        {property: 'og:type', content: 'website'},
        {property: 'og:url', content: domain},
        {property: 'og:locale', content: 'en_US'},
        {property: 'og:title', content: title },
        {property: 'og:description', content: description },
        {property: 'og:image', content: ''},
        // {property: 'og:image', content: ''},
        // {property: 'og:image:width', content: '545'},
        // {property: 'og:image:height', content: '478'}

      ]
    }
  },
}
// inject the serverconfig if its on the browser
if(typeof window !== 'undefined') {
  config = Object.assign({},config,window.__serverConfig)
}
module.exports = config